import axios from "axios";
export const internalIpV6 = () => { };

let ipRequest;

export const internalIpV4 = () => {
    const cachedIp = sessionStorage.getItem('device_ip');
    if (cachedIp) {
        return Promise.resolve(cachedIp);
    }

    if (!ipRequest) {
        ipRequest = axios.get('https://api.ipify.org/?format=json', { timeout: 2000 })
            .then((response) => {
                const ip = response.data?.ip || 'web-browser';
                sessionStorage.setItem('device_ip', ip);
                return ip;
            })
            .catch(() => 'web-browser');
    }

    return ipRequest;
}
